import { render } from "./PerformanceChart.vue?vue&type=template&id=082c20d6&scoped=true&ts=true"
import script from "./PerformanceChart.vue?vue&type=script&lang=ts"
export * from "./PerformanceChart.vue?vue&type=script&lang=ts"

import "./PerformanceChart.vue?vue&type=style&index=0&id=082c20d6&scoped=true&lang=less"

import exportComponent from "D:\\客户端h5\\operationmanual\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-082c20d6"]])

export default __exports__